module.exports = __webpack_public_path__ + "static/media/sitaLogo.1739a719.png";